module.exports = {"message":"Hello i18n !!","cutLocalImage":"upload Image","choseImage":"chose image","showAfterProcess":"show after process","downloadNewImage":"download new image","submit":"OK","reset":"reset","trunLeft":"trun left","trunRight":"trun right","cancel":"cancel","mainTitle":"Image croper or rotate ","txtDescription":"Use this tool to crop or rotate images."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = UpdR
// module chunks = 1